import { useStyles } from "@webapps/styles";
import { container } from "aws-amplify";
import planningColors from "pages/school/ClassesPage/Classes/colors/planningColors";
import { useCalendar } from "pages/school/ClassesPage/ClassesDetail/Stores/CalendarProvider";
import { useState } from "react";

function PlanningManagerTop() {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { state, dispatch } = useCalendar(); // Récupération du contexte

  const handleVisibleCategory = (category) => {
    dispatch({ type: "TOGGLE_CATEGORY_VISIBILITY", payload: category });
  };

  const handleToggle = () => {
    dispatch({ type: "TOGGLE_PERIOD_SELECTION" });
  };

  console.log("state.categoryTotals bien : ", state.categoryTotals);
  return (
    <div>


      <div className={classes.container}>

        <div className={classes.categoryContainer}>

          {/* {Object.entries(categoryTotals).map(([key, value]) => (
          <CircleWithLabel key={key}
            color={key === "FERIES" ? DAY_COLORS.FERIES : key === "VACANCES" ? DAY_COLORS.VACANCES : key === "ENTREPRISE" ? DAY_COLORS.ENTREPRISE : DAY_COLORS.FORMATION}
            label={`${key[0].toUpperCase() + key.slice(1).toLowerCase()} (${value.days} j - ${value.hours} h)`}

          /> */}

          {
            Object.entries(state.categoryTotals).map(([key, value]) => {
              return (
                <div key={key} className={classes.category}
                  onClick={() => handleVisibleCategory(key)}
                >
                  <div className={classes.duoInputTitle}>
                    <input type="checkbox" id={key + "-visibility"} name={key + "-visibility"}
                      checked={state.categoryTotals[key].visible}
                      style={{
                        accentColor: planningColors[key],
                        width: "18px",
                        height: "18px",
                      }}
                    />
                    <div className={cx(classes.categoryTitle, global.titleMediaQuery)}>{key === "FERIES" ? "Jours fériés" : key === "VACANCES" ? "Vacances" : `En ${key.toLocaleLowerCase()}`}</div>
                  </div>
                  <div className={cx(classes.categoryTotal, global.subTitleMediaQuery)}>{`${value.days}j - ${value.hours}h`}</div>
                </div>
              )
            })
          }
        </div>

      </div>
    </div>
  )
}

const styles = () => ({
  container: {
    position: 'sticky',
    top: '20px',
    // padding: '10px',
    zIndex: 1000,
  },
  infoSelectionContainer: {
    alignContent: 'center',
    alignItems: 'center',
    backgroundColor: '#004ac1',
    borderRadius: '10px',
    display: 'flex',
    flex: 'none',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    gap: '20px',
    height: 'min-content',
    justifyContent: 'flex-start',
    overflow: 'visible',
    padding: '20px',
    position: 'relative',
    marginLeft: "15px",
    marginRight: "15px",
    fontFamily: "Montserrat",
  },
  textInfoContainer: {
    width: "250px"
  },
  img: {
    width: "120px",
    transform: "rotate(9deg)",
  },
  title: {
    color: "#A8CAFF",
    fontSize: "15px",
    fontWeight: "600",
    maxWidth: "250px"
    // fontFamily: "Montserrat",
  },
  subTitle: {
    fontSize: "13.5px",
    // fontFamily: "Montserrat",
    color: "#A8CAFF",
    maxWidth: "250px"
  },
  boldSpan: {
    fontWeight: "bold",
  },
  infoText: {
    fontSize: "13.5px",
    color: "#0060F9",
    fontFamily: "Montserrat",
    fontWeight: "500",
  },
  inputContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    backgroundColor: "white",
    color: "#0060F9",
    padding: '8px',
    borderRadius: "400px"

  },
  toggleSwitch: {
    position: 'relative',
    display: 'inline-block',
    width: '50px',
    height: '24px',
  },
  input: {
    opacity: "0",
    width: "0",
    height: "0",

    "&:checked + .slider": {
      backgroundColor: '#0060F9',
    },

    "&:checked + .slider:before": {
      transform: 'translateX(26px)',
      backgroundColor: "white"
    },
  },
  slider: {
    position: 'absolute',
    cursor: 'pointer',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#75A8FB',
    transition: '0.4s',
    borderRadius: '24px',

    "&:before": {
      position: 'absolute',
      content: '""',
      height: '18px',
      width: '18px',
      left: '3px',
      bottom: '3px',
      backgroundColor: '#0060F9',
      transition: '0.4s',
      borderRadius: '50%',
    },
  },
  categoryContainer: {
    display: 'flex',
    gap: '10px',
    // padding: '10px',
    // backgroundColor: "white",
    fontFamily: "Montserrat",
    "@media only screen and (max-width: 1070px)": {
      flexWrap: "wrap",
    }
  },
  category: {
    fontFamily: "Montserrat",
    // padding: '10px',
    borderRadius: '10px',
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "10px",
    cursor: "pointer",
    // transition on hover

    width: "25%",
    border: "1px solid transparent",
    "&:hover": {
      transition: "0.3s",
      borderColor: "#0060F9"
      //   scale: "0.9"
    },
    "@media only screen and (max-width: 1070px)": {
      width: "calc(50% - 7.5px)",
    },
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    }
  },
  duoInputTitle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
  },
  categoryTitle: {
    // fontSize: "15px",
    fontWeight: "500",
    color: "#152652",
    // marginRight: "7px"
  },
  categoryTotal: {
    // fontSize: "15px",
    fontWeight: "600",
    color: "#152652",
    fontStyle: "italic"
  },
});

export default PlanningManagerTop;